import { format } from 'date-fns';
import { CommonUtilities } from '../../commonUtils';

export default class GenerationAllServices {

    static statementHistoryHeader =
        [
            {
                headerName: 'Email Date',
                type: "Email",
                headerMap: "dateCreated"
            },
            {
                headerName: 'Download Date',
                type: "Download",
                headerMap: "dateCreated"
            },
            {
                headerName: 'Generate Date',
                type: "Generate",
                headerMap: "dateCreated"
            },
            {
                headerName: 'Live OR Draft',
                type: "Email",
                headerMap: "liveORDraft"
            },
            {
                headerName: 'Period Selected',
                type: "Email/Download/Generate",
                headerMap: "periodSelected"
            },
            {
                headerName: 'UserName',
                type: "Email/Download/Generate",
                headerMap: "userName"
            },
            {
                headerName: 'LoggedUserEmail',
                type: "Email",
                headerMap: "loggedUserEmail"
            },
            {
                headerName: 'Other CC',
                type: "Email",
                headerMap: "liveCC"
            },
            {
                headerName: 'method',
                type: "Download",
                headerMap: "method"
            },
            {
                headerName: 'Report Type',
                type: "Email/Download/Generate",
                headerMap: "reportType"
            },
            {
                headerName: 'Royalty Period',
                type: "Email/Download/Generate",
                headerMap: "royPeriod"
            }

        ]

    static statmentHistoryListing(data: any) {
        var url = 'contract/statement/project/statmentHistory';
        return CommonUtilities.postData(url, data);
    }

    static emailTemplateListing() {
        var url = 'client/getEmailUserTemplate';
        return CommonUtilities.getData(url);
    }

    static emailTemplateList(data: any) {
        var url = 'client/getEmailUserTemplate/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }


    static approvalListCheck(data: any) {
        var url = 'contract/statement/project/approvalListCheck'
        return CommonUtilities.postData(url, data);
    }

    static emailStatment(data: any) {
        var url = 'contract/statement/project/email'
        return CommonUtilities.postData(url, data);
    }

    static generate_Statment(data: any) {
        var url = 'contract/statement/project/generate'
        return CommonUtilities.postData(url, data);
    }


    static downloadStatment(data: any) {
        var url = 'contract/statement/project/download'
        return CommonUtilities.postData(url, data);
    }



    static getClientDetails() {
        var url = 'client/getClientDetails'
        return CommonUtilities.getData(url);
    }

    static saveEmailUserTemplate(data: any) {
        var url = 'client/saveEmailUserTemplate';
        return CommonUtilities.postData(url, data);
    }

    static statementQueueValidationListing(data: any) {
        var url = 'approval/statementQueue/queue/validation?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static statementExport(data: any) {
        const url = 'contracts/financialPerformance?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.exportWithToken('POST', url, {}, '_blank', data.type);
    };

    static publishToAffiliate(data: any) {
        var url = 'Contract/statementSummary/publishToAffiliate';
        return CommonUtilities.postData(url, data);
    }

    static generateStatment(data: any) {
        var url = 'contract/statement/project/generate';
        return CommonUtilities.postData(url, data);
    }
}